export function isType<T>(x: any, propertyToCheck: keyof T): x is T {
    return (x as T)[propertyToCheck] !== undefined;
}